export function GmailIcon16({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="16" height="16" rx="2" fill="#F4F2ED" />
      <path d="M3 5.5L8 9l5-3.5V11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5.5z" fill="#EA4335" />
      <path d="M3 5.5L8 9l5-3.5L8.5 3h-1L3 5.5z" fill="#FBBC04" />
      <path d="M8 9l5-3.5L13 11a1 1 0 0 1-.55.9L8 9z" fill="#34A853" />
      <path d="M3 5.5L2.55 11.9A1 1 0 0 1 3 11V5.5L8 9 3 5.5z" fill="#4285F4" />
    </svg>
  )
}

export function OutlookIcon16({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="16" height="16" rx="2" fill="#0078D4" />
      <path
        d="M3.25 5.25h9.5v5.5H3.25V5.25zm1 .75l3.25 2.1 3.25-2.1v-.5L8 7.35 4.25 5.5v.5z"
        fill="#fff"
      />
    </svg>
  )
}
